"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _breadcrumbnav_styles = _interopRequireDefault(require("./breadcrumbnav_styles"));

var _breadcrumbnav_definition = _interopRequireDefault(require("./breadcrumbnav_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ++++++++++ --------------- EXPORT : BREADCRUMB NAV --------------- ++++++++++ */


var BreadCrumbNav = (0, _reactJss.default)(_breadcrumbnav_styles.default)(function (props) {
  var getWrapLink = function getWrapLink(item) {
    return _react.default.createElement(_index.Link, {
      name: "breadcrumbitem",
      type: 'internal',
      action: item.action
    }, _react.default.createElement(_index.Icon, {
      klass: 'page-icon',
      name: item.icon
    }), _react.default.createElement("span", {
      className: 'page-name'
    }, item.text));
  };

  var getAngleIcon = function getAngleIcon(index) {
    return index > 0 && _react.default.createElement(_index.Icon, {
      klass: 'sep',
      name: 'angle-right'
    });
  };

  var renderNavType = function renderNavType(type) {
    var currentPage = false;
    return props.items.map(function (item, index) {
      if (currentPage) return null;
      if (item.action === props.currentPage) currentPage = true;
      return _react.default.createElement("div", {
        className: "".concat(type, "-breadcrumb-wrap breadcrumb-hover ").concat(index === props.items.length - 1 ? 'last-child' : '')
      }, getAngleIcon(index), getWrapLink(item));
    });
  };

  return _react.default.createElement("div", {
    className: "nav breadcrumb ".concat(props.classes.breadcrumbnav)
  }, _react.default.createElement("nav", {
    className: "name-crumbnav"
  }, renderNavType('normal'), renderNavType('horizontal')));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(BreadCrumbNav, _breadcrumbnav_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = BreadCrumbNav;
exports.default = _default;